function loadLoopVideo(video) {
  if (video.dataset.videoLoopLoaded === 'true') return;

  const sources = video.querySelectorAll('source[data-src]');
  if (!sources.length) return;

  video.dataset.videoLoopLoaded = 'true';
  sources.forEach((source) => {
    source.src = source.dataset.src;
  });
  video.load();

  const play = video.play();
  if (play && typeof play.catch === 'function') {
    play.catch(() => {});
  }
}

function initLoopVideos() {
  const videos = document.querySelectorAll('video[data-video-loop]');
  if (!videos.length) return;

  const start = () => {
    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadLoopVideo);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadLoopVideo(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '200px 0px' }
    );

    videos.forEach((video) => observer.observe(video));
  };

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initLoopVideos();

  // watch video
  document.querySelectorAll('.video [data-video-btn]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const isHosted = el.getAttribute('data-hosted') === 'true' ?? false;
      el.nextElementSibling.hidden = false;
      if (isHosted) {
        el.nextElementSibling.play();
      } else {
        el.nextElementSibling.removeAttribute('srcdoc');
      }
      if (el.querySelector('.video__play')) {
        el.querySelector('.video__play').remove();
      }
      el.closest('.video').classList.add('video--is-playing');
      return false;
    });
  });
});
